
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiRadarRangeProposal as ObiRadarRangeProposalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-radar-range-proposal.js';
 
 
 

 
 export const ObiRadarRangeProposal = createComponent({
   react: React,
   tagName: 'obi-radar-range-proposal',
   elementClass: ObiRadarRangeProposalElement,
   events: {
     
   }
  });
 
 